// 이모지가 없는 것은 직접 그린 작은 그림을 쓴다 (김밥: 이모지에는 오니기리·초밥만 있다).
// 문구에 {kimbap}처럼 쓰면 setLabel이 그 자리에 그림을 넣는다.

const svg = (body: string) => 'data:image/svg+xml,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">${body}</svg>`);

/** 김밥 한 줄 두 조각: 김(검은 초록) 테두리, 흰 밥, 단무지·당근·시금치·햄·달걀 속. */
const slice = (cx: number, cy: number) => `
  <circle cx="${cx}" cy="${cy}" r="9.6" fill="#1D2A22"/>
  <circle cx="${cx}" cy="${cy}" r="8" fill="#FBF8EF"/>
  <circle cx="${cx - 3}" cy="${cy - 4.6}" r="0.7" fill="#E9E3D2"/><circle cx="${cx + 4.4}" cy="${cy + 2.8}" r="0.7" fill="#E9E3D2"/><circle cx="${cx - 4.8}" cy="${cy + 2.2}" r="0.7" fill="#E9E3D2"/>
  <rect x="${cx - 1.4}" y="${cy - 3.6}" width="2.8" height="2.8" rx="0.4" fill="#F4C93A"/>
  <rect x="${cx + 1.2}" y="${cy - 1.2}" width="2.6" height="2.6" rx="0.4" fill="#F08A2C"/>
  <rect x="${cx - 3.8}" y="${cy - 1.2}" width="2.6" height="2.6" rx="0.4" fill="#4E9A3A"/>
  <rect x="${cx - 1.3}" y="${cy + 1}" width="2.6" height="2.6" rx="0.4" fill="#E8718A"/>
  <rect x="${cx - 1.2}" y="${cy - 1.1}" width="2.4" height="2.2" rx="0.4" fill="#F7DC74"/>`;

export const ICONS: Record<string, string> = {
  kimbap: svg(slice(19.5, 13) + slice(12, 19.5)),
};

/** el에 문구를 넣는다. {이름}은 ICONS의 그림으로 바꾼다. */
export function setLabel(el: HTMLElement, text: string): void {
  el.replaceChildren();
  for (const part of text.split(/(\{\w+\})/)) {
    const m = /^\{(\w+)\}$/.exec(part), src = m && ICONS[m[1]!];
    if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.className = 'icon'; el.append(img); }
    else if (part) el.append(part);
  }
}
